<div class="login login--add-scroll">
    <h1 class="sr-only">{{ 'Login' | translate }}</h1>
    <div class="login__content">
        <core-brand-logo [isNotLink]="true"></core-brand-logo>
        <div class="login__wrapper">
            <p>
                <a
                    [core-analytics]="{ action: 'Back to login', category: 'RESET' }"
                    class="login__goback"
                    routerLink="/login">
                    {{ 'Go back' | translate }}
                </a>
            </p>

            <h2>{{ 'Password reset' | translate }}</h2>
            <p>{{ 'Enter a new password for your account.' | translate }}</p>
            <p>
                {{
                    'Passwords must be at least 10 characters long, contain an upper-case and a lower-case letter, a number, and a special character. Avoid common passwords or passwords you use elsewhere.'
                        | translate
                }}
            </p>

            @if (errorMessage) {
                <div class="alert alert-danger" [innerHTML]="errorMessage"></div>
            }
            @if (successMessage) {
                <div class="alert alert-success" [innerHTML]="successMessage"></div>
            }

            @if (!successMessage) {
                <form [formGroup]="resetForm" (ngSubmit)="reset()">
                    <div
                        [ngClass]="{
                            'form-group--success': resetForm.get('password')!.valid,
                            'form-group--error':
                                resetForm.get('password')!.touched && !resetForm.get('password')!.valid,
                        }"
                        class="form-group">
                        <label for="password">
                            {{ 'Password' | translate }} *
                            <span class="sr-only">{{ 'required' | translate }}</span>
                        </label>
                        <div class="form-control-wrapper form-control-wrapper--password">
                            <input
                                class="form-control"
                                formControlName="password"
                                id="password"
                                name="password"
                                placeholder="{{ 'Enter a new password' | translate }}"
                                type="{{ passwordType }}" />
                            <span
                                [hidden]="!resetForm.get('password')!.valid"
                                aria-live="polite"
                                class="form-control-feedback">
                                <span class="sr-only">{{ 'Correct' | translate }}</span>
                            </span>
                        </div>
                        <button
                            (click)="togglePasswordType()"
                            [ngClass]="{ 'btn-show-active': passwordType === 'text' }"
                            class="btn btn-show"
                            tabindex="-1"
                            type="button">
                            {{ 'Toggle to show/hide password' | translate }}
                        </button>
                        <span [hidden]="resetForm.get('password')!.valid" aria-live="polite" class="sr-only">
                            {{ 'Incorrect' | translate }}
                        </span>
                        <p
                            [hidden]="!resetForm.get('password')!.touched || resetForm.get('password')!.valid"
                            class="alert alert-warning small">
                            {{
                                'Passwords must be at least 10 characters long, contain an upper-case and a lower-case letter, a number, and a special character. Avoid common passwords or passwords you use elsewhere.'
                                    | translate
                            }}
                        </p>
                    </div>
                    <div
                        [ngClass]="{
                            'form-group--success':
                                resetForm.get('confirmPassword')!.valid &&
                                resetForm.get('confirmPassword')!.value === resetForm.get('password')!.value,
                            'form-group--error':
                                resetForm.get('confirmPassword')!.touched &&
                                (!resetForm.get('confirmPassword')!.valid ||
                                    resetForm.get('confirmPassword')!.value !== resetForm.get('password')!.value),
                        }"
                        class="form-group">
                        <label for="confirmPassword">
                            Confirm your password *
                            <span class="sr-only">{{ 'required' | translate }}</span>
                        </label>
                        <div class="form-control-wrapper form-control-wrapper--password">
                            <input
                                class="form-control"
                                formControlName="confirmPassword"
                                id="confirmPassword"
                                name="confirmPassword"
                                placeholder="Confirm your new password"
                                type="{{ passwordType }}" />
                            @if (
                                resetForm.get('confirmPassword')!.touched &&
                                resetForm.get('confirmPassword')!.valid &&
                                resetForm.get('confirmPassword')!.value === resetForm.get('password')!.value
                            ) {
                                <span aria-live="polite" class="form-control-feedback">
                                    <span class="sr-only">{{ 'Correct' | translate }}</span>
                                </span>
                            }
                            <button
                                (click)="togglePasswordType()"
                                [ngClass]="{ 'btn-show-active': passwordType === 'text' }"
                                class="btn btn-show"
                                tabindex="-1"
                                type="button">
                                Toggle to show/hide password
                            </button>
                            <p
                                [hidden]="
                                    !resetForm.get('confirmPassword')!.touched ||
                                    resetForm.get('password')!.value === resetForm.get('confirmPassword')!.value
                                "
                                aria-live="polite"
                                class="note small text-danger unconfirmed">
                                Please enter the same password as above
                            </p>
                        </div>
                    </div>
                    <div class="row no-gutters">
                        <div class="col-12 pl-lg-1 my-2">
                            <button
                                [class.spinner]="submitting"
                                [core-analytics]="{ action: 'Reset', category: 'RESET' }"
                                [disabled]="
                                    submitting ||
                                    !resetForm.valid ||
                                    resetForm.get('password')!.value !== resetForm.get('confirmPassword')!.value
                                "
                                class="btn btn-primary btn-block btn-lg float-end"
                                id="js-reset-btn"
                                type="submit">
                                <core-spinner name="reset"></core-spinner>
                                <span>{{ 'Reset' | translate }}</span>
                            </button>
                        </div>
                    </div>
                </form>
            }

            <core-login-footer></core-login-footer>
        </div>
    </div>

    <core-demo-config-toggle></core-demo-config-toggle>
</div>
